export const passwordMinSize = 8
// TODO перенести в конфиг
export const passwordRegex = /^(?!.*[^\x21-\x7E])(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W]*$/
